import ComponentCostsCard from './ComponentCostsCard';
export default ComponentCostsCard;
